import React from 'react';
import { Loader2, Save } from 'lucide-react';
import './MemberFormSaveButton.css';

export default function MemberFormSaveButton({
  onClick,
  isSaving = false,
  label = '儲存',
  savingLabel = '儲存中...'
}) {
  return (
    <button
      type="button"
      className="member-form-save-button"
      onClick={onClick}
      disabled={isSaving}
      aria-busy={isSaving}
    >
      {isSaving
        ? <Loader2 size={18} className="member-form-save-button__spinner" aria-hidden="true" />
        : <Save size={18} aria-hidden="true" />}
      {isSaving ? savingLabel : label}
    </button>
  );
}
